import React, { useState, useEffect } from "react";
import { getAuth, applyActionCode } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const VerifyPage = () => {
  const [verificationStatus, setVerificationStatus] =
    useState("Đang xác minh...");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth(); // ✅ moved inside useEffect

    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get("mode");
    const actionCode = urlParams.get("oobCode");

    if (mode === "verifyEmail" && actionCode) {
      applyActionCode(auth, actionCode)
        .then(() => {
          setVerificationStatus("Xác minh email thành công!");
          setSuccess(true);
        })
        .catch((error) => {
          console.error("Lỗi xác minh email:", error);
          setError(error.message);
          setVerificationStatus("Xác minh email thất bại.");
        });
    } else {
      setVerificationStatus("Đường dẫn xác minh không hợp lệ.");
      setError("Đường dẫn xác minh không hợp lệ.");
    }
  }, [navigate]); // ✅ clean dependency array

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-96">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">
          Xác Minh Email
        </h2>

        <p className="mb-4 text-gray-700">{verificationStatus}</p>

        {error && <div className="text-red-500 mb-4">Lỗi: {error}</div>}

        <button
          className={`${
            success
              ? "bg-blue-500 hover:bg-blue-700"
              : "bg-gray-400 hover:bg-gray-600"
          } text-white font-bold py-2 px-4 rounded mt-4`}
          onClick={handleLoginClick}
        >
          {success ? "Đăng nhập" : "Về trang đăng nhập"}
        </button>
      </div>
    </div>
  );
};

export default VerifyPage;
